'use client'

import { useState } from 'react'
import { useRouter } from 'next/navigation'
import { Button } from '@/components/ui/button'
import { MessageSquarePlus, Loader2 } from 'lucide-react'

interface ShareExperienceButtonProps {
  className?: string
}

export default function ShareExperienceButton({ className }: ShareExperienceButtonProps) {
  const [isLoading, setIsLoading] = useState(false)
  const router = useRouter()

  const handleClick = async () => {
    setIsLoading(true)
    
    try {
      router.push('/leave-review')
    } catch (error) {
      console.error('Navigation error:', error)
      setIsLoading(false)
    }
    // Note: Don't set loading to false here as navigation will unmount the component
  }

  return (
    <Button 
      onClick={handleClick}
      disabled={isLoading}
      className={`
        w-full sm:w-auto min-h-[48px] px-6 py-3
        bg-[var(--color-brand-primary)] hover:bg-[var(--color-brand-primary-hover)]
        text-white font-medium
        transform-gpu will-change-transform
        transition-all duration-200 ease-out
        hover:scale-105 active:scale-95
        disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none
        focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
        ${className || ''}
      `}
      aria-label="Share your rental experience"
      aria-describedby="share-experience-description"
    >
      {isLoading ? (
        <>
          <Loader2 className="w-5 h-5 animate-spin mr-2" />
          <span>Loading...</span>
        </>
      ) : (
        <>
          <MessageSquarePlus className="w-5 h-5 mr-2" />
          <span>Share Your Experience</span>
        </>
      )}
    </Button>
  )
} 